<div class="widget-config" *ngIf="data">
  <form nz-form #formRef="ngForm">
    <!-- 名称 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">名称</nz-form-label>
      <nz-form-control>
        <input nz-input #nameInput="ngModel" name="name" type="text" [(ngModel)]="data.name" />
      </nz-form-control>
    </nz-form-item>

    <!-- 标题 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">标题</nz-form-label>
      <nz-form-control>
        <input nz-input #labelInput="ngModel" name="label" type="text" [(ngModel)]="data.label" />
      </nz-form-control>
    </nz-form-item>

    <!-- 标题宽度 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">标题宽度</nz-form-label>
      <nz-form-control>
        <nz-input-number #labelWidthInput="ngModel" name="labelWidth" [(ngModel)]="data.labelWidth" [nzMin]="0" [nzMax]="9999">
        </nz-input-number>
      </nz-form-control>
    </nz-form-item>

    <!-- 表单栅格 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">表单栅格</nz-form-label>
      <nz-form-control>
        <nz-input-number #spanInput="ngModel" name="span" [(ngModel)]="data.span" [nzMin]="1" [nzMax]="24"></nz-input-number>
      </nz-form-control>
    </nz-form-item>

    <!-- 是否可见 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">是否可见</nz-form-label>
      <nz-form-control>
        <nz-switch #displayInput="ngModel" name="display" [(ngModel)]="data.display"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- 是否必填 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">是否必填</nz-form-label>
      <nz-form-control>
        <nz-switch #requiredInput="ngModel" name="required" [(ngModel)]="data.required"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- 占位内容 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">占位内容</nz-form-label>
      <nz-form-control>
        <input nz-input #placeholderInput="ngModel" name="placeholder" type="text" [(ngModel)]="data.placeholder" />
      </nz-form-control>
    </nz-form-item>

    <!-- 组件特定配置 -->
    <div d-component [is]="configComponentName" [data]="data"></div>
  </form>
</div>
